export default __webpack_public_path__ + "static/media/Features-mode.b7b9c62e.svg";